import { Box } from '@mui/material';
import Slider from 'react-slick';
import {
  CarouselControlsArrowsIndex,
  CarouselControlsDownload,
} from './carousel';
import { useMemo, useRef, useState } from 'react';
import { download } from 'src/utils/download';

export default function Images({
  images,
  width,
  height,
  objectFit,
  downloadName = 'image',
}) {
  const carouselRef = useRef();
  const [currentIndex, setCurrentIndex] = useState(0);

  const settings = {
    speed: 500,
    dots: false,
    arrows: false,
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    beforeChange: (_current, next) => setCurrentIndex(next),
  };

  const CarouselItem = ({ src }) => {
    return (
      <Box
        component="img"
        sx={{ objectFit: objectFit ?? 'cover', borderRadius: '8px' }}
        src={src}
        width={width}
        height={height}
      />
    );
  };

  const fileExtension = useMemo(() => {
    // The url has the form http://s3-something.amazonaws.com/blah/blah/blah.png
    // We need to extract that ".png" extension.
    const url = images[currentIndex];
    const components = url.split('.');

    // The extension is the final "component".
    // If there isn't an extension then guess PNG. (We can't really give a better default here)
    const extension = components.lastItem ?? 'png';

    return '.' + extension;
  }, [images, currentIndex]);

  return (
    <Box width={width} height={height} position="relative">
      <Slider ref={carouselRef} {...settings}>
        {images.map((image, i) => (
          <CarouselItem key={i} src={image} />
        ))}
      </Slider>

      <CarouselControlsArrowsIndex
        index={currentIndex}
        total={images.length}
        onNext={() => carouselRef.current.slickNext()}
        onPrevious={() => carouselRef.current.slickPrev()}
      />
      <CarouselControlsDownload
        onClick={() =>
          download(images[currentIndex], downloadName + fileExtension)
        }
        index={currentIndex}
        total={images.length}
      />
    </Box>
  );
}
